/** Angular Imports */
import { NgModule } from '@angular/core';

/** Angular Font Awesome Imports */
import { FontAwesomeModule, FaIconLibrary} from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import {
  faAnchor,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBook,
  faBriefcase,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faCloud,
  faCog,
  faCogs,
  faCommentAlt,
  faDollarSign,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileUpload,
  faFileWord,
  faFillDrip,
  faHandHoldingUsd,
  faHome,
  faKey,
  faLink,
  faList,
  faListUl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMinusCircle,
  faMoneyBillAlt,
  faMoneyCheck,
  faPencilAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRandom,
  faRoad,
  faSearch,
  faShieldAlt,
  faSignOutAlt,
  faSitemap,
  faSync,
  faTable,
  faTachometerAlt,
  faTag,
  faTags,
  faRedo,
  faTimesCircle,
  faTrash,
  faUndo,
  faUniversity,
  faUserCircle,
  faUser,
  faUsers,
  faUserShield,
  faDownload,
  faUpload,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faTimes,
  faStickyNote,
  faStop,
  faAngleDown,
  faAngleUp,
} from '@fortawesome/free-solid-svg-icons';

/** Add icons to the library for convenient access in other components. */
library.add(
  faAnchor,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBook,
  faBriefcase,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faCloud,
  faCog,
  faCogs,
  faCommentAlt,
  faDollarSign,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileUpload,
  faFileWord,
  faFillDrip,
  faHandHoldingUsd,
  faHome,
  faKey,
  faLink,
  faList,
  faListUl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMinusCircle,
  faMoneyBillAlt,
  faMoneyCheck,
  faPencilAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRandom,
  faRoad,
  faSearch,
  faShieldAlt,
  faSignOutAlt,
  faSitemap,
  faSync,
  faTable,
  faTachometerAlt,
  faTag,
  faTags,
  faRedo,
  faTimesCircle,
  faTrash,
  faUndo,
  faUniversity,
  faUserCircle,
  faUser,
  faUsers,
  faUserShield,
  faDownload,
  faUpload,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faTimes,
  faStickyNote,
  faStop,
  faAngleDown,
  faAngleUp,
  faUserCircle,
  fas,
);

/**
 * Icons Module
 *
 * Angular Font Awesome module is exported here.
 */
@NgModule({
  exports: [FontAwesomeModule]
})
export class IconsModule { 
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
}
}
